import { PaginateModel } from "./core.interface";
import { Attachment } from "./attachment.interface";

export interface ProductMenuRequest {
    method?: string | null;
    url?: string | null;
    query?: Record<string, unknown> & { limit?: number; offset?: number };
}

export function hasProductMenuRequest(menu: ProductMenuRequest): boolean {
    return !!(menu.method?.trim() || menu.url?.trim());
}

export function isRecentProductsMenu(menu?: ProductMenuRequest): boolean {
    return menu?.method?.trim().toUpperCase() === 'GET'
        && /(?:^|\/)Product\/recent-products\/?$/i.test(menu.url?.trim() ?? '');
}

export function isBasicProductGroup(menu: { group?: number | string }): boolean {
    return menu.group === 0 || menu.group === '0' || menu.group === 'Basic';
}

export interface CategoryModel extends PaginateModel {
    data: Category[];
}

export interface Category {
    method?: string | null;
    url?: string | null;
    id: number;
    categoryId: string;
    name: string;
    slug: string;
    slugKey: string;
    description: string;
    type: string;
    parent_id?: number;
    category_image?: Attachment;
    category_image_id?: number;
    category_icon?: Attachment;
    category_icon_id?: number;
    commission_rate?: number;
    children: Category[] | undefined;
    query: any;
    products_count: number;
    status: boolean;
    isActive: boolean;
    selected: boolean;
    created_by_id?: number;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
    childrenSelected: boolean;
    isShow: boolean;
}
